import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { CollectionsApi } from '../tokens/collections.token';
import {
  CollectionDisputeRequest,
  CollectionNotice,
  CollectionPaymentPlanRequest,
} from '../models/financing-servicing.model';

/**
 * REST-only implementation of `CollectionsApi` (EPIC-4 / EM-500, Story 10 — EM-510).
 *
 * Calls the Story-8 `CollectionResource` (notice-id-keyed) under `/services/embedded/api/collections`.
 * `GET /collections` returns an empty array (NOT an error) when the party has no notices — the
 * empty-state success banner (PRD F-09). Rides the Keycloak bearer. Rule 07 / Rule 10 — no Mock.
 * Rule 09 — errors propagate.
 */
@Injectable()
export class CollectionsRestService implements CollectionsApi {
  private readonly http = inject(HttpClient);

  list(): Observable<CollectionNotice[]> {
    return this.http.get<CollectionNotice[]>(API_PATHS.COLLECTIONS);
  }

  acknowledge(noticeId: number): Observable<CollectionNotice> {
    return this.http.post<CollectionNotice>(`${API_PATHS.COLLECTIONS}/${noticeId}/acknowledge`, {});
  }

  proposePaymentPlan(noticeId: number, request: CollectionPaymentPlanRequest): Observable<CollectionNotice> {
    return this.http.post<CollectionNotice>(`${API_PATHS.COLLECTIONS}/${noticeId}/payment-plan`, request);
  }

  dispute(noticeId: number, request: CollectionDisputeRequest): Observable<CollectionNotice> {
    return this.http.post<CollectionNotice>(`${API_PATHS.COLLECTIONS}/${noticeId}/dispute`, request);
  }
}
